var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_21976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H0V70H70V0Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 31H16V37.3467H25.3253V66H32.7139V37.3467H42V31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3974 38.9448C64.3974 38.9448 60.9346 36.6211 57.0202 36.6211C53.1058 36.6211 51.697 38.4925 51.697 40.4926C51.697 45.6547 66 45.1381 66 55.5266C66 71.5294 44.1918 64.4316 44.1918 64.4316V56.7547C44.1918 56.7547 48.362 59.9167 53.3635 59.9167C58.365 59.9167 58.1751 56.6261 58.1751 56.1738C58.1751 51.3997 44 51.3996 44 40.8162C44 26.4275 64.6532 32.1042 64.6532 32.1042L64.3974 38.9448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_21976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.8f255884977587efdcec47dbf39958ed.svg";
export { ForwardRef as ReactComponent };